
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class OperatorMissionPriorityPalletsDetailDataTableCheckRenderer extends Vue {
  @Prop() props!: any;
}
